/*
  color: 38808E, 90BFB1, CDA39E, 8FA9A8, F4BA9C, F8DEC1 - http://i0.wp.com/s-media-cache-ak0.pinimg.com/736x/e5/f7/b1/e5f7b12acc6e2c68ad861d1bc6b0325c--color-palette-teal-peach-color-scheme.jpg
  367D94, A9BBBC, 775A7D, 4A4173, 071125,
  D4B351 yellow-text, 70BAA1, 48929D, 344B74, 2E3355, 090E26 (dark) https://i.pinimg.com/736x/90/3e/6d/903e6d8360185a4460d92b2ebe26ca87--aqua-blue-bedrooms-blue-bedroom-colors.jpg
*/
export const ProjectData = [
  {
    category: "projects",
    tags: [
      "personal projects",
      "ReactJS",
      "Koa",
      "NodeJS",
      "Heroku",
      "CircleCI",
    ],
    path: "can-i-afford-to",
    name: "Can I Afford To?",
    links: [
      {
        name: "demo",
        val: "https://app.caniafford.to",
        icon: "external-link",
      },
    ],
    date: "2020",
    about: "Project your financial future",
    long_desc: `Web app to help people budget, pay off debt, and plan for the future by creating month-to-month personal finance projections`,
    stack: [
      "React/Redux",
      "NodeJS",
      "koa",
      "JavaScript",
      "CircleCI",
      "Docker",
      "Heroku",
    ],
    mainphoto:
      "https://s3.amazonaws.com/melissawei/portfolio/caniaffordto/caniaffordto_12_20.gif",
    mainStill:
      "https://s3.amazonaws.com/melissawei/portfolio/caniaffordto/caniaffordto_12.20.png",
    video:
      "https://s3.amazonaws.com/melissawei/portfolio/caniaffordto/caniaffordto_12_20.mov",
    bgcolor: "#F8DEC1",
  },
  {
    category: "projects",
    tags: [
      "personal projects",
      "ReactJS",
      "Web Audio API",
      "node",
      "socket.io",
    ],
    path: "synthfony-v1",
    name: "Synthfony v1",
    links: [
      {
        name: "demo",
        val: "https://beatfreq.surge.sh/collab/funky-tunes",
        icon: "external-link",
      },
    ],
    date: "2018",
    about: "Collaborative music making",
    long_desc: `Create a room and start making tunes with friends`,
    stack: ["React/JS", "node", "socket.io", "JavaScript"],
    mainphoto:
      "https://s3.amazonaws.com/melissawei/portfolio/synthfony/synthfony_12_20.gif",
    mainStill:
      "https://s3.amazonaws.com/melissawei/portfolio/synthfony/synthfony_12_20.png",
    video:
      "https://s3.amazonaws.com/melissawei/portfolio/synthfony/synthfony_12_20.mov",
    bgcolor: "#775A7D",
  },
  {
    category: "projects",
    tags: [
      "personal projects",
      "ReactJS",
      "Elixir",
      "Phoenix",
      "PostgreSQL",
      "front-end",
      "API-backend",
    ],
    path: "projectmode-v2",
    name: "Project Mode",
    links: [
      { name: "version 1", val: "/project/projectmode-v1", icon: "link" },
      {
        name: "github/react",
        val: "https://github.com/ProjectModeIo/project-mode-react",
        icon: "github",
      },
      {
        name: "github/api",
        val: "https://github.com/ProjectModeIo/project-mode-api",
        icon: "github",
      },
    ],
    date: "ongoing project",
    about: `Platform to share and collaborate on projects.`,
    long_desc: `An app intended to encourage collaboration on projects and forming a community around bringing
     ideas to fruition.\n\n
     Subscribe to "channels" that interest you (hobbies, passions, hot topics you feel strongly about), list your skillset,
     and start following (and creating!) projects that align with your interests.\n\n
     This project is still a work in progress and I would very much like collaborators!  If you're interested, please shoot me an email.`,
    stack: ["React/JS", "Elixir", "Phoenix", "PostgreSQL", "HTML/CSS"],
    mainphoto:
      "https://s3.amazonaws.com/melissawei/portfolio/projectmode/projectmode-v2-gif.gif",
    mainStill:
      "https://s3.amazonaws.com/melissawei/portfolio/projectmode/projectmode-v2-still.gif",
    video:
      "https://s3.amazonaws.com/melissawei/portfolio/projectmode/projectmode-v2-vid.mov",
    bgcolor: "#4BA7A0",
  },
  {
    category: "experiments",
    tags: ["clocks", "timers", "time"],
    path: "clocks",
    name: "Clocks",
    links: [
      {
        name: "demo",
        val: "https://codepen.io/5ftwndr/pen/ooKaRK",
        icon: "codepen",
      },
    ],
    date: "12/9/2017",
    about: `Visualizing time.`,
    long_desc: `Hoping to turn this into a time series!  Stay tuned.`,
    stack: ["Javascript"],
    mainphoto:
      "https://s3.amazonaws.com/melissawei/portfolio/clocks/clock-v1-gif.gif",
    mainStill:
      "https://s3.amazonaws.com/melissawei/portfolio/clocks/clock-v1-still.gif",
    video:
      "https://s3.amazonaws.com/melissawei/portfolio/clocks/clock-v1-vid.mov",
    bgcolor: "#A635BA",
    photos: [
      {
        url: "https://s3.amazonaws.com/melissawei/portfolio/clocks/clock-v1-gif.gif",
        desc: `#1: Digital clock.`,
      },
    ],
  },
  {
    category: "experiments",
    tags: ["client work", "ReactJS", "front-end", "music", "night life"],
    path: "synesthesia",
    name: "Synesthesia",
    links: [
      {
        name: "demo",
        val: "http://synesthesia.melissawei.com",
        icon: "external-link",
      },
    ],
    date: "12/8/2017",
    about: `Turning your words into melodies and rainbows.`,
    long_desc: `Just a small, fun experiment with using weighted randomization to play music
     and place colors on the screen.`,
    stack: ["Javascript"],
    mainphoto:
      "https://s3.amazonaws.com/melissawei/portfolio/synesthesia/synesthesia-gif.gif",
    mainStill:
      "https://s3.amazonaws.com/melissawei/portfolio/synesthesia/synesthesia-still.gif",
    video:
      "https://s3.amazonaws.com/melissawei/portfolio/synesthesia/synesthesia-vid.mov",
    bgcolor: "#ab9fe7",
  },
  {
    category: "projects",
    tags: ["client work", "ReactJS", "front-end", "music", "night life"],
    path: "auxilarateny",
    name: "AuxilarateNY",
    links: [
      {
        name: "client site",
        val: "http://auxilarateny.com",
        icon: "external-link",
      },
    ],
    date: "8/15/2017",
    about: `AuxilarateNY is an event promoter based in New York City that hosts monthly
     local events.`,
    long_desc: `AuxilarateNY hosts local events and parties in New York City featuring local DJs.
     They wanted a simple website where people could see their current and past events, join
     their mailing list, and view photos and curated music.\n\n
     Their website is currently a lightweight, front-end only single page React App.`,
    stack: ["React/JS", "HTML/CSS"],
    mainphoto:
      "https://s3.amazonaws.com/melissawei/portfolio/auxilarate/auxilarate-gif.gif",
    mainStill:
      "https://s3.amazonaws.com/melissawei/portfolio/auxilarate/auxilarate-still.gif",
    video:
      "https://s3.amazonaws.com/melissawei/portfolio/auxilarate/auxilarate-vid.mov",
    bgcolor: "#802C32",
  },
  {
    category: "experiments",
    tags: ["artwork", "ReactJS", "front-end"],
    path: "giraffes",
    name: "Giraffes.io",
    links: [
      {
        name: "github",
        val: "https://github.com/mwei2509/giraffes.io",
        icon: "github",
      },
      { name: "demo", val: "http://giraffes.io", icon: "external-link" },
    ],
    date: "5/2/2017",
    about: "Fun with overscroll!  Scribbles of a zoo.",
    long_desc: `This was an experimentation with overscrolling.  Illustrations are exported
     as SVGs and "drawn" based on the scroll progression`,
    stack: ["React/JS", "HTML/CSS"],
    mainphoto:
      "https://s3.amazonaws.com/melissawei/portfolio/giraffes/portfolio_giraffesio.gif",
    mainStill:
      "https://s3.amazonaws.com/melissawei/portfolio/giraffes/portfolio_giraffesio_still.gif",
    video:
      "https://s3.amazonaws.com/melissawei/portfolio/giraffes/ezgif.com-crop+(2).mov",
    bgcolor: "#FCEFCB",
  },
  {
    category: "projects",
    tags: [
      "team projects",
      "ReactJS",
      "Ruby on Rails",
      "PostgreSQL",
      "productivity",
    ],
    path: "corkly",
    name: "Corkly",
    links: [
      {
        name: "github",
        val: "https://github.com/mwei2509/corkly-react",
        icon: "github",
      },
      { name: "demo", val: "http://corkly.co", icon: "external-link" },
    ],
    date: "4/25/2017",
    about:
      "Pin notes and images to a virtual bulletin board. Collaborate on personal boards, or create public boards to share with everybody.",
    long_desc: `Corkly was created with Ruby on Rails and Postgres API backend
        and a React/Redux frontend framework, using JWT and BCrypt authentication.
        Corkly sticky notes and sidebar features custom, handwritten CSS.\n\n
        Sticky notes can be created with a simple double-click on the screen.
        Photos can be uploaded from the user's computer or drag-and-dropped from
        an outside website.`,
    gif: "demo gif",
    stack: ["Ruby on Rails", "React/JS", "Postgres", "HTML/CSS"],
    mainphoto:
      "https://s3.amazonaws.com/melissawei/portfolio/corkly/corkly-gif.gif",
    mainStill:
      "https://s3.amazonaws.com/melissawei/portfolio/corkly/corkly-still.gif",
    video:
      "https://s3.amazonaws.com/melissawei/portfolio/corkly/corkly-vid.mov",
    bgcolor: "#F1D2AF",
    photos: [
      {
        header: false,
        feature: true,
        url: "https://s3.amazonaws.com/melissawei/portfolio/corkly/LunPDNY.png",
        desc: `Start out with an empty corkboard and double click anywhere
          to create a note.  Save your personal bulletin boards and keep track of them
          in your personalized sidebar.`,
      },
      {
        header: false,
        feature: true,
        url: "https://s3.amazonaws.com/melissawei/portfolio/corkly/5AWQ3oD.gif",
        desc: `Drag and drop your favorite images from other websites (or upload
          them from your computer)`,
      },
      {
        header: false,
        feature: true,
        url: "https://s3.amazonaws.com/melissawei/portfolio/corkly/LNiXAiP.gif",
        desc: `Collaborate on boards with friends. Adding a friend as a collaborator
          adds your board to their list of boards. Private boards are only accessible
          to its collaborators.`,
      },
    ],
  },
  {
    category: "projects",
    tags: ["personal projects", "ReactJS", "front-end"],
    path: "passanote",
    name: "Pass a Note",
    links: [
      {
        name: "github",
        val: "https://github.com/mwei2509/pass-a-note",
        icon: "github",
      },
      {
        name: "demo",
        val: "https://mwei2509.github.io/pass-a-note/",
        icon: "external-link",
      },
    ],
    date: "4/12/2017",
    about: "A blank canvas to speak your mind",
    long_desc: `Pass-a-note is a simple, single-page React app where users can double click anywhere
      on their screen and create quotes. Font family, opacity, and size are randomly
      genrated, and words created can be edited, moved, and deleted to string together thoughts in
      a creative, fun manner.`,
    gif: "demo gif",
    stack: ["React/JS"],
    mainphoto:
      "https://s3.amazonaws.com/melissawei/portfolio/passanote/passanote-gif.gif",
    mainStill:
      "https://s3.amazonaws.com/melissawei/portfolio/passanote/passanote-still.gif",
    video:
      "https://s3.amazonaws.com/melissawei/portfolio/passanote/passanote-vid.mov",
    bgcolor: "#E4A490",
  },
  {
    category: "projects",
    tags: [
      "personal projects",
      "ReactJS",
      "front-end",
      "Google Maps API",
      "transportation",
      "productivity",
    ],
    path: "routefinder",
    name: "RouteFinder",
    links: [
      {
        name: "github",
        val: "https://github.com/mwei2509/route-finder-react",
        icon: "github",
      },
      {
        name: "demo",
        val: "http://route-finder.surge.sh/",
        icon: "external-link",
      },
    ],
    date: "date",
    about:
      "Find the optimized waypoint through multiple addresses, perfect for planning your most efficient route.",
    long_desc: `RouteFinder is a single-page React app that uses the Google Directions API to find
      the optimized waypoint to get from origin to destination through multiple stops.`,
    gif: "demo gif",
    stack: ["React/JS", "HTML/CSS", "Bootstrap CSS library"],
    mainphoto:
      "https://s3.amazonaws.com/melissawei/portfolio/routefinder/routefinder-gif.gif",
    mainStill:
      "https://s3.amazonaws.com/melissawei/portfolio/routefinder/routefinder-still.gif",
    video:
      "https://s3.amazonaws.com/melissawei/portfolio/routefinder/routefinder-vid.mov",
    bgcolor: "#80ACAA",
    photos: [
      {
        header: false,
        feature: true,
        url: "https://s3.amazonaws.com/melissawei/portfolio/routefinder/kED9iyh.png",
        desc: `Step 1: Enter an origin, a destination (or check round trip), and add as many waypoints as necessary.`,
      },
      {
        feature: true,
        url: "https://s3.amazonaws.com/melissawei/portfolio/routefinder/FF4Mmsr.png",
        desc: `Step 2: Magic!  The app uses Google's optimized waypoint API to find the best route from your origin
        to your destination through your chosen waypoints, prividing directions and a map`,
      },
    ],
  },
  {
    category: "projects",
    tags: [
      "team project",
      "Ruby on Rails",
      "Websockets",
      "Redis",
      "chat app",
      "social messaging app",
    ],
    path: "ghostchat",
    name: "GhostChat",
    links: [
      {
        name: "github",
        val: "https://github.com/mwei2509/ghostchat",
        icon: "github",
      },
      { name: "demo", val: "http://www.ghostchat.io/", icon: "external-link" },
    ],
    date: "4/8/2017",
    about:
      "Quickly create public or private expiring group chats. No user registration required!",
    long_desc: `GhostChat uses a Ruby on Rails and Postgres SQL database backend framework with Action Cable
      websockets to enable real-time chatting.  Users can create group chats in as easy as two clicks - no
      need to create names for groups or usernames (when no names are provided, a random, unique name is generated).\n\n
      GhostChat uses symmetric server-side encryption to store messages.  Chats expire after a certain amount of time,
      and all messages are automatically destroyed`,
    gif: "demo gif",
    stack: ["Ruby on Rails", "jQuery", "Postgres", "HTML/CSS"],
    mainphoto:
      "https://s3.amazonaws.com/melissawei/portfolio/ghostchat/ghostchat-gif.gif",
    mainStill:
      "https://s3.amazonaws.com/melissawei/portfolio/ghostchat/ghostchat-still.gif",
    video:
      "https://s3.amazonaws.com/melissawei/portfolio/ghostchat/ghostchat-vid.mov",
    bgcolor: "#6060b7",
  },
  {
    category: "experiments",
    tags: [
      "personal projects",
      "chrome extension",
      "ReactJS",
      "front-end",
      "browser extensions",
      "network requests",
    ],
    path: "adfunkr",
    name: "AdFunkr",
    links: [],
    date: "ongoing project",
    about:
      "A chrome extension to monitor and selectively block network requests",
    long_desc: `Many third party ad trackers use query parameters on network requests to track your
     online activities and collect personal information about you.
     \n\n This extension monitors network requests by third party scripts and parses out their query parameters.
     You can keep track of and/or block certain keywords or phrases and turn on notifications to get
     alerted when said keyword is being tracked.  The intention is to increase awareness of when and how
     personal information is collected on the average internet user`,
    stack: ["React/JS", "HTML/CSS", "Chrome Extension APIs"],
    mainphoto:
      "https://s3.amazonaws.com/melissawei/portfolio/adfunkr/adfunkrnobx-gif.gif",
    mainStill:
      "https://s3.amazonaws.com/melissawei/portfolio/adfunkr/adfunkrnobx-still.gif",
    video:
      "https://s3.amazonaws.com/melissawei/portfolio/adfunkr/adfunkrnobx-vid.mov",
    bgcolor: "#70BAA1",
  },
  {
    category: "experiments",
    tags: ["personal projects", "ReactJS", "front-end", "css"],
    path: "devbox",
    name: "DevBox",
    links: [],
    date: "ongoing project",
    about:
      "(WIP) An interface to create html elements, manipulate CSS, and see the changes in real time",
    long_desc: `As somebody who likes to focus on building out functionality in projects, I always
     become impatient when the time comes to style and make things look nice.  I've had so many projects
     remain unfinished because I lose interest the second I need to start playing with CSS.\n\n
     I started this app in order to better understand flexbox CSS.  I wanted to create a UI to
     easily see the differences as I toggle through the properties, and that snowballed into wanting to
     create an app that 1) does all of the above with all CSS properties, and 2) creates classes for you
     based on your finished styling.  The end goal is to be able to create fully designed webpages and
     export them in HTML with an acompanying stylesheet.`,
    stack: ["React/JS", "Ruby on Rails", "HTML/CSS", "PostgreSQL"],
    mainphoto:
      "https://s3.amazonaws.com/melissawei/portfolio/devbox/devbox-gif.gif",
    mainStill:
      "https://s3.amazonaws.com/melissawei/portfolio/devbox/devbox-still.gif",
    video:
      "https://s3.amazonaws.com/melissawei/portfolio/devbox/devbox-vid.mov",
    bgcolor: "#D4B351",
  },
  {
    category: "experiments",
    tags: ["scrum", "gif", "mobile", "giphy", "agile"],
    path: "scrummy",
    name: "Scrummy",
    links: [
      {
        name: "demo",
        val: "https://codepen.io/5ftwndr/pen/ooKaRK",
        icon: "codepen",
      },
    ],
    date: "12/9/2017",
    about: `Visualizing time.`,
    long_desc: `Hoping to turn this into a time series!  Stay tuned.`,
    stack: ["Javascript"],
    mainphoto:
      "https://s3.amazonaws.com/melissawei/portfolio/clocks/clock-v1-gif.gif",
    mainStill:
      "https://s3.amazonaws.com/melissawei/portfolio/clocks/clock-v1-still.gif",
    video:
      "https://s3.amazonaws.com/melissawei/portfolio/clocks/clock-v1-vid.mov",
    bgcolor: "#A635BA",
    photos: [
      {
        url: "https://s3.amazonaws.com/melissawei/portfolio/clocks/clock-v1-gif.gif",
        desc: `#1: Digital clock.`,
      },
    ],
  },
  {
    category: "experiments",
    tags: ["game", "terminal", "drop-seven"],
    path: "drop-seven",
    name: "DropSeven",
    links: [
      {
        name: "github",
        val: "https://github.com/mwei2509/drop-seven",
        icon: "github",
      },
    ],
    date: "7/1/2019",
    about: `Go version of mobile app game DropSeven`,
    long_desc: `Practice with Go by recreating a simple terminal version of the game DropSeven`,
    stack: ["Go"],
    mainphoto:
      "https://s3.amazonaws.com/melissawei/portfolio/drop-seven/drop-seven-gif.gif",
    mainStill:
      "https://s3.amazonaws.com/melissawei/portfolio/drop-seven/drop-seven-still.gif",
    video:
      "https://s3.amazonaws.com/melissawei/portfolio/drop-seven/drop-seven-cropped-vid.mov",
    bgcolor: "#D4B351",
    photos: [],
  },
];



// WEBPACK FOOTER //
// ./src/content/projectdata.js